const data = {
  pageName: "TopUp",
  errorMsg: "", // Λυπούμαστε πολύ. Συνέβη κάποιο σφάλμα.
  serverNotification: "", // A simple server notification message.
  pageUnavailable: false,

  usps: {
    title: "Τι πρέπει να λάβω υπόψη πριν την ανανέωση;",
    items: [
      {
        image: null,
        icon: "calls-contacts-hi-dark",
        text:
          "Έχεις επιλέξει τον σωστό αριθμό για να ανανεώσεις τον χρόνο ομιλίας;",
        title: "calls-contacts-hi-dark",
        key: 1490639290682,
        url: null
      },
      {
        image: null,
        icon: "saving-hi-dark",
        text:
          "Επαρκεί το ποσό ανανέωσης για το πακέτο θα επιλεγεί μετά την ανανέωση;",
        title: "saving-hi-dark",
        key: 1490639290709,
        url: null
      },
      {
        image: null,
        icon: "payg-hi-dark",
        text: "Έχει πραγματοποιηθεί επέκταση υπολοίπου πρόσφατα;",
        title: "payg-hi-dark",
        key: 1490639290741,
        url: null
      },
      {
        image: null,
        icon: "bundles-hi-dark",
        text: "Υπάρχει πακέτο με αυτόματη ενεργοποίηση;",
        title: "bundles-hi-dark",
        key: 1490639290771,
        url: null
      }
    ]
  },

  services: {
    translations: {
      url: "topUp/translations",
      params: {}
    }
  }
};

exports.data = data;
